import { useAccount } from './useAccount';

export const useIsLoggedIn = () => {
  const query = useAccount();
  return {
    ...query,
    data: { ...query.data, isLoggedIn: query.isSuccess },
  };
};
